import {IHttpService} from "angular";
import {ClientNotesRecords} from "../../../models/ClientNotesRecord";

export class ClientNotesService {

    public static readonly id = "clientNotesService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
    }

    public async list(accountId: number): Promise<ClientNotesRecords> {
        const url = `/tradefloor/api/accounts/${accountId}/notes`;
        const response = await this.$http.get<ClientNotesRecords>(url);
        return response.data;
    }

    public async create(content: string, noteTag: string, accountId: number): Promise<void> {
        const url = `/tradefloor/api/accounts/${accountId}/notes`;
        var params = {'content':content, 'noteTag':noteTag};
        await this.$http.post(url, params);
    }

    public async remove(noteId: number, accountId: number): Promise<void> {
        const url = `/tradefloor/api/accounts/${accountId}/notes/${noteId}`;
        await this.$http.delete(url);
    }

    public async update(noteId: number, accountId: number, content: string, noteTag: string): Promise<void> {
        const url = `/tradefloor/api/accounts/${accountId}/notes/${noteId}`;
        var params = {'content':content, 'noteTag':noteTag};
        await this.$http.put(url, params);
    }
}
